import AudioPlayer from "./components/AudioPlayer/AudioPlayer";
import Header from "./components/Header/Header";
import Chatbot from "./components/Chatbot/Chatbot";
import CookieBanner from "./components/Utils/CookieBanner";
import { DataProvider } from "./components/Terminal/DataContext";
import TerminalContainer from "./components/Terminal/TerminalContainer";
import { Provider } from "./context";

function App() {
  return (
    <>
      <Provider>
        <DataProvider>
          <AudioPlayer />
          <TerminalContainer />
        </DataProvider>
        <Header />
        <Chatbot />
        <CookieBanner />
      </Provider>
    </>
  );
}

export default App;
